import AppHeader from '../AppHeader'

export default {
  name: 'master-consumable-item-list',
  created () {
    if (window.sessionStorage.getItem('master_consumable_item_search')) {
      const data = JSON.parse(window.sessionStorage.getItem('master_consumable_item_search'))
      this.categoryId = data.categoryId
      this.supplierId = data.supplierId
      this.searchQueryName = data.searchQueryName
    }
    this.getConsumableItems()
    this.getCategories()
    this.getShopOrderSuppliers()
  },
  data () {
    return {
      consumableItems: [],
      categories: [],
      suppliers: [],
      getCategoriesEndFlag: false,
      getSuppliersEndFlag: false,
      categoryId: '',
      supplierId: '',
      searchQueryName: '',
    }
  },
  computed: {
  },
  components: {
    AppHeader
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'MasterConsumableItemNew' || to.name === 'MasterConsumableItemEdit' || to.name === 'MasterConsumableItemDetail' || to.name === 'MasterConsumableItemShopStockCountList') {
      const savedata = {
        'categoryId': this.categoryId,
        'supplierId': this.supplierId,
        'searchQueryName': this.searchQueryName
      }
      window.sessionStorage.setItem('master_consumable_item_search', JSON.stringify(savedata))
    } else {
      window.sessionStorage.removeItem('master_consumable_item_search')
    }
    next()
  },
  methods: {
    async getConsumableItems () {
      const data = {
        name: this.searchQueryName,
        category_id: this.categoryId,
        supplier_id: this.supplierId
      }
      let res = await this.$store.dispatch('CONSUMABLE_ITEM_GET', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.consumableItems = res.data
    },
    async getCategories () {
      let data = {}
      const res = await this.$store.dispatch('GET_CATEGORY_LIST', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.categories = res.categories
      this.getCategoriesEndFlag = true
    },
    async getShopOrderSuppliers () {
      const data = {}
      const res = await this.$store.dispatch('GET_SUPPLIER_LIST', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.suppliers = res.suppliers
      this.getSuppliersEndFlag = true
    },
    async deleteConsumableItem (id) {
      if (!window.confirm('この消耗品を削除しますか？')) {
        return
      }
      const data = {
        id: id
      }
      await this.$store.dispatch('CONSUMABLE_ITEM_DELETE', data)
              .catch(err => {
                console.log(err)
                window.alert('適正在庫数が1以上の店舗が存在するため削除出来ません')
                return
              })

      this.getConsumableItems()
    },    
    goProductNew () {
      this.$router.push({path: '/master_consumable_item/new'})
    },
    goConsumableItemEdit (consumableItemId) {
      this.$router.push({path: '/master_consumable_item/' + `${consumableItemId}` + '/edit'})
    },
    goConsumableItemDetail (consumableItemId) {
      this.$router.push({path: '/master_consumable_item/' + `${consumableItemId}`})
    },
    goConsumableItemStockCountList (consumableItemId) {
      this.$router.push({path: '/master_consumable_item/' + `${consumableItemId}` + '/stock_count'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-consumable-item-list.js